var exports = {
  "kL": "xa15a2ab7--2497b5--container",
  "z3": "xa15a2ab7--2497b5--error",
  "fF": "xa15a2ab7--2497b5--options",
  "Jn": "xa15a2ab7--2497b5--review-container",
  "h_": "xa15a2ab7--2497b5--description",
  "ax": "xa15a2ab7--2497b5--icon-group-block",
};

module.exports = exports;
